<template>
    <div class="input-field" :class="{ 'no-label': !label }">
        <textarea
            :id="name"
            ref="input"
            v-model="input_localValue"
            :name="name"
            :class="[{ dirty: input_dirty, hidden, submitted, monospace, 'auto-grow': autoGrow }, inputClassList]"
            :pattern="input_computedPattern"
            :placeholder="placeholder"
            :required="required"
            :readonly="readonly"
            :autofocus="autofocus"
            :maxlength="maxlength"
            :autocomplete="autocompleteValue"
            @input="updateInput"
            @blur="input_handleBlur"
            @select="input_handleSelect"
        />

        <label :for="name">{{ label }}</label>

        <div v-if="$slots.help" class="assistive-text">
            <slot name="help" />
        </div>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';

import inputMixin from '../../mixins/input';

export default {
    name: 'DsTextAreaField',

    mixins: [inputMixin],

    props: {
        /**
         * Automatically resize the height to fit the text inside
         */
        autoGrow: Boolean,

        /**
         * Maximum length of the text area field
         */
        maxlength: {
            type: Number,
            default: 2000,
        },

        /**
         * Display textarea value in monospace.
         */
        monospace: Boolean,
    },

    data() {
        return {
            delay: 300,
        };
    },

    created() {
        this.adjustHeight = debounce(this.adjustHeight, this.delay);
    },

    mounted() {
        if (this.autoGrow) {
            this.adjustHeight();
        }
    },

    computed: {
        autocompleteValue() {
            const { autocomplete } = this;

            if (autocomplete === true) {
                return 'on';
            }

            if (autocomplete === false) {
                return 'off';
            }

            return autocomplete;
        },
    },

    methods: {
        adjustHeight() {
            const element = this.$refs.input;

            return this.$nextTick(() => {
                if (element) {
                    element.style.height = 'auto';
                    element.style.height = `${element.scrollHeight + 8}px`;
                }
            });
        },

        updateInput($event) {
            if (this.autoGrow) {
                this.adjustHeight();
            }

            this.input_updateInput($event.target.value);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../styles/common";

    .input-field {
        @include input-field;

        textarea {
            @include input-text;

            &.monospace {
                font: $font-family-monospace;
                resize: both;
            }
        }
    }
</style>
